import { useParams } from "react-router-dom";
import { useState } from "react";

import { Text, Box, Heading, Image } from "@chakra-ui/react";

//import project list
import { ProjectList } from "./projects-list";

//import member info
import listOfTeamMembers from "../Team Members/team-members-list";

//import navbar
import Navbar from "../Navbar/Navbar";

//import footer
import Footer from "../footer/footer";

export default function DynamicProject() {
  const { projectName } = useParams();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      {ProjectList.filter((element) => element.slug === projectName).map(
        (item) => {
          return (
            <div key={item.id}>
              <section id="title">
                <Box
                  minHeight="100vh"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  backgroundImage={item.backgroundImage}
                  backgroundSize="cover"
                  backgroundRepeat="no-repeat"
                >
                  <Heading
                    fontSize={{
                      base: "35px",
                      md: "40px",
                      lg: "45px",
                      xl: "50px",
                    }}
                    fontWeight={700}
                    textAlign="center"
                  >
                    {item.title}
                  </Heading>
                  <Text
                    fontSize="16px"
                    width="50%"
                    textAlign={{ base: "justify", md: "center", xl: "center" }}
                    margin="10px"
                  >
                    {item.shortDescription}
                  </Text>
                  <Box display="flex" gap="20px">
                    <Box
                      cursor="pointer"
                      background="#edf0ef"
                      color="black"
                      padding="1rem"
                      width="122px"
                      _hover={{
                        background: "black",
                        color: "white",
                      }}
                      _focus={{
                        textDecoration: "none",
                      }}
                      transition="background 0.2s ease-in"
                    >
                      <Text fontSize="16px">View Project</Text>
                    </Box>
                    <Box
                      cursor="pointer"
                      background="#edf0ef"
                      color="black"
                      padding="1rem"
                      width="122px"
                      _hover={{
                        background: "black",
                        color: "white",
                      }}
                      _focus={{
                        textDecoration: "none",
                      }}
                      transition="background 0.2s ease-in"
                    >
                      <Text fontSize="16px">View Article</Text>
                    </Box>
                  </Box>
                </Box>
              </section>
              <section id="how-it-works">
                <Box
                  minHeight="100vh"
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                >
                  <Box textAlign="center" marginBottom="30px">
                    <Text fontSize="3xl" fontWeight={700}>
                      How it works
                    </Text>
                  </Box>
                  <Box padding="50px">
                    <Text textAlign="justify">{item.details}</Text>
                  </Box>
                  <Box display="flex" justifyContent="center">
                    <Image src={item.image2} />
                  </Box>
                </Box>
              </section>
              <section id="team-members" style={{ background: "white" }}>
                <Box minHeight="100vh">
                  <Box textAlign="center" marginBottom="30px" paddingTop="80px">
                    <Text fontSize="3xl" fontWeight={700}>
                      Project Members
                    </Text>
                  </Box>
                  <Box
                    display="flex"
                    flexWrap="wrap"
                    justifyContent="center"
                    alignItems="center"
                    gap="20px"
                  >
                    {item.projectMembers.map((item, index) => {
                      return (
                        <Box key={index}>
                          {listOfTeamMembers
                            .filter((element) => element.name === item)
                            .map((item) => {
                              return (
                                <Box
                                  key={item.id}
                                  background="white"
                                  height="350px"
                                >
                                  <Image
                                    src={item.image}
                                    width="326px"
                                    height="250px"
                                  />
                                  <Text
                                    fontSize="20px"
                                    textAlign="center"
                                    marginTop="10px"
                                  >
                                    {" "}
                                    {item.name}
                                  </Text>
                                </Box>
                              );
                            })}
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              </section>
            </div>
          );
        }
      )}
      <Footer />
    </>
  );
}
